import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	padding: 1.5rem 2rem;

	${minWidth('desktop')} {
		padding: 6.66rem 11.11rem 0 4rem;
		min-height: 100vh;
	}
`;

export const Heading = styled.h2`
	color: ${palette('gray7')};
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 2rem;
	text-align: center;
	line-height: 1.25;
	${fontSize(FontSizes.xl)};

	${minWidth('desktop')} {
		font-size: 2rem;
	}
`;
